import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Navbar({ variant = "light" }) {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isDark = variant === "dark";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-paper border-b border-rule"
          : isDark
          ? "bg-transparent"
          : "bg-paper/80 backdrop-blur-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-4 md:py-5 flex items-center justify-between gap-4">
        <Link
          to="/"
          data-testid="link-home"
          className="group flex items-baseline gap-2 md:gap-3 flex-shrink-0"
        >
          <span
            className={`font-serif text-lg md:text-xl tracking-tight whitespace-nowrap ${
              scrolled || !isDark ? "text-navy" : "text-paper"
            }`}
          >
            Nimisha Mohan
          </span>
          <span className="eyebrow text-gold hidden md:inline">Srivastava</span>
        </Link>

        <nav className="flex items-center gap-4 sm:gap-6 md:gap-8">
          <NavLink
            to="/"
            active={location.pathname === "/"}
            dark={isDark && !scrolled}
            testid="nav-home"
          >
            Profile
          </NavLink>
          <NavLink
            to="/insights"
            active={location.pathname.startsWith("/insights")}
            dark={isDark && !scrolled}
            testid="nav-insights"
          >
            Insights
          </NavLink>
          <a
            href="#contact"
            data-testid="nav-contact"
            className={`eyebrow transition-colors ${
              isDark && !scrolled
                ? "text-paper/80 hover:text-gold"
                : "text-navy hover:text-gold"
            }`}
            onClick={(e) => {
              if (location.pathname !== "/") return;
              e.preventDefault();
              document
                .getElementById("contact")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
}

function NavLink({ to, children, active, dark, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`eyebrow transition-colors relative ${
        dark
          ? "text-paper/80 hover:text-gold"
          : active
          ? "text-navy"
          : "text-ink-muted hover:text-navy"
      }`}
    >
      {children}
      {active && (
        <span className="absolute -bottom-2 left-0 right-0 h-[2px] bg-gold" />
      )}
    </Link>
  );
}
